<template>
  <Section>

    <Container>

      <FadeIn class="mx-auto max-w-2xl lg:text-center" v-if="content.title">
        <div class="mb-2 md:mb-4" v-if="content.pretitle">
          <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
            {{ content.pretitle }}
          </span>
        </div>
        <h2 class="text-section-title">{{ content.title }}</h2>
        <div
        v-if="content.subtitle"
        class="text-subtitle" 
        v-interpolation 
        v-html="content.subtitle"
        ></div>
      </FadeIn>

      <div :class="content.title ? 'mt-8 md:mt-12 lg:mt-16' : '-mt-16 md:-mt-[80px] lg:-mt-16'" class="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-6 lg:gap-8 xl:gap-12">
        <ElementBrick v-for="(item, index) in content.items" :hasTitle="item.bricks_item_id.title" :sectionIndex="index" :content="item.bricks_item_id" />
      </div>

      <FadeIn v-if="content.cta" class="mt-16 md:mt-20 lg:text-center lg:mt-24">  
        <ElementButton 
        v-for="(cta, index) in content.cta" 
        :key="'cta-'+index"
        :url="cta.url" 
        :type="cta.type"
        :size="cta.size"
        :arrow="cta.arrow"
        >
          {{ cta.title }}
        </ElementButton>
      </FadeIn>
      <FadeIn 
      v-else-if="!isFeaturesPage"
      class="mt-16 md:mt-20 lg:text-center lg:mt-24"
      >
        <ElementButton 
        url="/features" 
        type="primary"

        :arrow="true"
        >
          View all features
        </ElementButton>
      </FadeIn>
  
    </Container>

  </Section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  sectionIndex: {
    type: Number
  }
})
const route = useRoute()
const isFeaturesPage = computed(() => {
  return route.path.includes('/features')
})
</script>